export default { // 弹窗提示、警告
	/**
	 * 未使用的编码代号：da ~ wz、xb ~ xz
	 *  */
	a0: 'Do you want to save the modified data?', //是否保存已经修改的数据？
	a1: 'Please select the order to copy first', //请先选择需要复制的订单
	a2: 'The order can only be copied from the original order!', //订单只能是原单才能复制!
	a3: 'Is not cancelled or system invalid order, replication is not allowed', //非已取消或系统作废订单，不允许复制
	a4: 'Only copy the original order of [Warehouse Shipping, Platform Shipping]', //只能对【仓库发货，平台发货】订单状态的原单进行复制操作
	a5: 'Please select an order to copy!', //请选择一条需要复制的订单！
	a6: 'Please select the record for review!', //请选择需要审核的记录！
	a7: 'Please select the order required to be invoiced', //请选择需要开票的订单
	a8: 'Please select an order', //请选择一条订单
	a9: 'Please select the order required to cancel!', //请选择需要取消的订单！
	aa: 'Provincial and municipal information is required!', //省市信息必填!
	ab: 'consignee name is illegal, please fill in again!', //收货人姓名不合法，请重新填写！
	ac: 'Ship nee required!', //收货人必填!
	ad: 'Ship nee phone required!', //收货人手机必填!
	ae: 'Phone number is not legal, please fill in again!', //电话号码不合法，请重新填写！
	af: 'consignee address required!', //收货人地址必填!
	ag: 'Return details must have line data!', //退货明细必须有行数据！
	ah: 'Exchange details must have line data!', //换货明细必须有行数据！
	ai: 'The exchange amount must equal the return amount!', //换货金额必须等于退货金额！
	aj: 'The total amount of return cannot be less than 0. Please save it again after modification!', //退货总金额不能小于0，请修改后重新保存！
	ak: 'Please enter the correct replacement postage!', //请输入正确的换货邮费!
	al: 'Return item details quantity cannot be 0!', //退货明细数量不能为0！
	am: 'Return details color cannot be empty!', //退货明细颜色不能为空！
	an: 'Return details size cannot be empty!', //退货明细尺码不能为空！
	ao: 'Return detail bar code cannot be empty!', //退货明细条码不能为空！
	ap: 'The exchange quantity cannot be empty', //换货明细换货数量不能为空
	aq: 'The replacement details color cannot be empty', //换货明细颜色不能为空
	ar: 'The placement details size cannot be empty', //换货明细尺码不能为空
	as: 'The barcode of the replacement detail cannot be empty',//换货明细条码不能为空
	at: 'Availability inventory query failed',//可用库存查询失败
	au: 'New return and exchange order failed!',
	av: 'The quantity of application is inconsistent with the quantity of warehousing. Is the after-sale review confirmed?',
	aw: 'Please select a detail to delete!',
	ax: 'Batch deleting details is not allowed!',
	ay: 'Delete success!',
	az: 'There are multiple records in the original platform order number, please use the order number to inquire！',
	b0: 'Select the record that you want to intercept！',
	b1: 'The trading platform is Dangdang, Vipshop jitx, Jingdong orders are not allowed to open orders',
	b2: 'Orders in interception and refund are not allowed to demolish orders! ',
	b3: 'Only allow to split orders to be reviewed and missing! ',
	b4: 'Only one order can be split at a time! ',
	b5: 'Please select a new check-back record! ',
	b6: 'Please select a record! ',
	b7: "The order status of the order that needs to be cancelled and the system is invalid! ",
	b8: 'Orders need to be shipped before adding new refunds! ',
	b9: 'Please select a record that requires missing inventory reuse! ',
	ba: 'No data query! ',
	bb: 'Query query data! ',
	bc: 'Please select a piece of data! ',
	bd: 'Only one order record is selected! ',
	be: 'Please select the store to download',
	bf: 'Commodity ID and Time must fill in one of them',
	bg: 'Please enter the store to download! ',
	bh: 'Billing time billing code cannot be empty simultaneously! ',
	bi: 'Billing time cannot be empty',
	bj: 'Billing time cannot cross the month',
	bk: 'Days of the billing period are less than or equal to 11 days',
	bl: 'The Supplier ID cannot be empty! ',
	bm: 'Bill code cannot be empty',
	bn: 'Order Download task has been sent, task ID:',
	bo: 'Please go to the interface download task table to see the download progress! ',
	bp: 'Please select a date or enter Order number',
	bq: 'Change time, commodity PID, commodity code required',
	br: 'Please select the query time to download',
	bs: 'Please select the date you entered or enter the order number',
	bt: 'Store and platform time cannot be empty',
	bu: 'Change time and change number cannot be empty',
	bv: 'Checkback modification time and checkback number cannot also be both empty',
	bw: 'Please enter the platform time or refund order number',
	bx: 'Please enter one of the number number or modification time to download',
	by: 'Confirm the synchronous inventory? ',
	bz: 'Print out the selected lines? ',
	c0: 'Please select a record that requires out of stock inventory! ',
	c1: 'Please select the record required to change to platform shipping! ',
	c2: 'Please select a record that a volume check back! ',
	c3: 'Non-pending order exists in the selected order, inventory release is not allowed! ',
	c4: 'Are you sure of the inventory release that will be taken up by the selected order? ',
	c5: 'Please select the order requiring an inventory release! ',
	c6: 'Please select the need to modify the logistics records! ',
	c7: 'Please select the need to modify the shipping warehouse records! ',
	c8: 'Please select the record required to modify the notes! ',
	c9: 'Please choose the record of advance delivery requiring a deposit for pre-sale! ',
	ca: 'Printing, please be available later...',
	cb: 'Manual accounting for orders succeeded! ',
	cc: 'Consolidation accounting was successful! ',
	cd: 'Order checked by page',
	ce: 'Select the Order by filter',
	cf: 'Commodity SKU',
	cg: 'The sku cannot be empty! ',
	ch: 'The current operation did not confirm the disassembly order, do you confirm the refresh? ',
	ci: 'Already in the original state, no action! ',
	cj: 'Split quantity cannot be greater than the quantity to be dismantled; not disassembly! ',
	ck: 'Query failed! ',
	cl: 'Please select the details required to be split! ',
	cm: 'No orders to split! ',
	cn: 'Split number cannot be 0! ',
	co: 'Please select the demolition list details to add to be dismantled, before dismantling the order! ',
	cp: 'Rule Name Required',
	cq: 'Rule type required',
	cr: 'Please set up the warehouse first',
	cs: 'Delete failed! ',
	ct: 'Please select the details to delete',
	cu: 'Please save main table information',
	cv: 'Warehouse Required',
	cw: 'Warehouse Priority Required',
	cx: 'New Success',
	cy: 'New failure',
	cz: 'Delete details successfully',
	d0: 'Please select the record for an urgent shipment! ',
	d1: 'Please select the record that needs to replace the giveaway! ',
	d2: 'Please select the record required to add a giveaway! ',
	d3: 'Please select the record that needs to delete the giveaway! ',
	d4: 'Please select a record to remove! ',
	d5: 'Please select a record that needs to cancel the Hold order! ',
	d6: 'Server request failed',
	d7: 'Please select the document to merge! ',
	d8: 'Select select document for action! ',
	d9: 'Current status exception, operation is not allowed! ',
	da: 'Modifying the discount succeeded',
	db: 'Please have a maintenance discount! ',
	dc: 'Please have a maintenance price! ',
	dd: 'Match succeeded',
	de: 'Please enter the quantity',
	df: 'Please select the data to be deleted',
	dg: 'Single barcode was added successfully',
	dh: 'Please select the warehouse first',
	di: 'Customer phone call is not legal! ',
	dj: 'Please select the details and then click Delete',
	dk: 'Creation date cannot be empty',
	dl: 'Time range cannot exceed 24 hours',
	dm: 'Platform barcode id, barcode, batch code] cannot be at the same time empty! ',
	dn: 'Platform commodity ID cannot be empty! ',
	do: 'Store store cannot be empty! ',
	dp: 'Barcode cannot be empty! ',
	dq: 'Please select the record that need to be replaced! ',
	dr: 'Batch processing is not allowed! ',
	ds: 'Document status is cancelled status cannot modify the seller notes! ',
	dt: 'Only the check status can be reviewed after sale, please reselect the data! ',
	du: 'Data loading in...',
	dv: 'Please select a detail to be replaced! ',
	dw: 'Please Select an order detail! ',
	dx: 'Data load failed! ',
	dy: 'The color or size does not exist in this item! ',
	dz: 'Only one order detail! ',
	e0: 'Are you sure to cancel the order? ',
	e1: 'Are you sure to cancel the Hold? ',
	e2: 'Please select the record that requires a Hold order! ',
	e3: 'The current operation performs a full export, and the export time may be relatively slow! Continue with the export? ',
	e4: 'The express will be redistributed to the query order data. Do you want to continue? ',
	e5: 'The warehouse will be redistributed to the query-out order data. Do you want to continue? ',
	e6: 'Batch batch batch return order to continue? ',
	e7: 'Only the orders to be reviewed can be consolidated',
	e8: 'The documents to be consolidated can only be non-delivered',
	e9: 'The pre-sale status of the documents to be consolidated can only be non-pre-sale',
	ea: 'HOLD Single Success',
	eb: 'Please select the item to replace! ',
	ec: 'You not choose to replace the current item! ',
	ed: 'Please fill in the filter criteria! ',
	ee: 'Warehouse storage physical warehouse required! ',
	ef: 'The reason for refusing to make money can not be empty! ',
	eg: 'No gifts to add! ',
	eh: 'Archives schedule ownership cannot be empty! ',
	ei: 'Please select a data replacement hanging tag first! ',
	ej: 'Not [out of stock] state, you cannot change the hanging tag operation! ',
	ek: 'Please enter the logistics order number! ',
	el: 'Please enter the pass WMS pick single field! ',
	em: 'Logistics company is required! ',
	en: 'Extension date cannot be empty! ',
	eo: 'Adjust the policy time and succeed',
	ep: 'Click on Cancel! ',
	eq: 'Query Condition <Entity Warehouse> <Document Date> <source document type> has at least one that is not empty! ',
	er: 'Success! ',
	es: 'Please fill the group name! ',
	et: 'There are duplicate priorities! ',
	eu: 'Setup the group successfully! ',
	ev: 'Please select the record that requires a counter-audit! ',
	ew: "Only allow warehouse delivery, platform delivery status order batch refund! ",
	ex: 'The JITX order does not allow a split! ',
	ey: 'Phone number must be a number, please modify',
	ez: 'Incorrect number of cell phones, please modify',
	f0: 'The shipping warehouse for the documents to be consolidated can only be non-empty',
	f1: 'Consolidation Order succeeded',
	f2: 'Consolidation order failed',
	f3: 'Unmerge order successfully',
	f4: 'Unmerge order failed',
	f5: 'Please select the data for no more than 80 orders! ',
	f6: "The order status of the order that needs to be cancelled and the system is invalid! ",
	f7: "There is no delivery order, no batch new return and exchange order operation! ",
	f8: 'An export is in progress',
	f9: 'Please fill in the full information, such as',
	fa: 'The mobile phone number cannot be empty! ',
	fb: 'Incorrect mobile phone number format! ',
	fc: 'The consignee address cannot be empty! ',
	fd: 'Ship nee address not correct format! ',
	fe: 'Only out order order allow for go back! ',
	ff: 'Make sure the order! ',
	fg: 'Only one commodity record is selected! ',
	fh: 'SKU code cannot be empty! ',
	fi: 'Please select the dimension needs to be generated! ',
	fj: 'Please select a product category! ',
	fk: 'Please select the supplier you to add! ',
	fl: 'This supplier already exists, do not add repeatedly! ',
	fm: 'Please select the data requiring a bulk application! ',
	fn: 'Please select the logistics order number',
	fo: 'No return order selected, please select a data before operation! ',
	fp: 'This return order has generated an uninvalid exchange type retail delivery order, cancellation is not allowed, continue to cancel the exchange type retail delivery order and return order',
	fq: 'Order status is not satisfied, address modification is not allowed!',
	fr: 'Check that the details contain non complimentary items, and do not delete them!',
	fs: 'Order information is inconsistent, and the merger is not allowed! ',
	ft: 'Orders are not allowed to merge by HOLD,! ',
	fu: 'Orders are time limit orders and consolidation is not allowed! ',
	fv: 'Merge orders support a maximum consolidation of 50 orders! ',
	fw: 'Orders are pre-sale order and unpaid, consolidation is not allowed! ',
	fx: 'Unmerged orders do not allow unconsolidation! ',
	fy: 'Verify that the selected order is unmerged? ',
	fz: 'Confirm that the selected orders are consolidated? ',
	g0: 'Shipper warehouse, which cannot be empty',
	g1: "The order has a non-giveaway deal amount of 0, are you sure to save the order? ",
	g2: 'Save not successfully',
	g3: 'Details query failed! ',
	g4: 'Details save failed! ',
	g5: 'Enter the barcode! ',
	g6: 'The barcode does not exist! ',
	g7: 'Determine the reverse-audit order? ',
	g8: 'Order status reviewed, counter-review address recommended',
	g9: 'Order status is not unconfirmed, missing, reviewed, distribution, address modification is not allowed',
	ga: 'Please select a record to notify WMS! ',
	gb: 'Verify that the WMS? is repassed ',
	gc: 'Only out of stock or pending orders are allowed to be replaced!',
	gd: 'Only when the status is to be approved and out of stock can you add gifts!',
	ge: 'The current document is',
	gf: 'Change order or not!',
	gg: 'Return details cannot be empty!',
	gh: 'No current platform number found!',
	gi: 'Exchange details cannot be empty!',
	gj: 'The total amount of final refund cannot be less than 0!',
	gk: 'The exchange amount is inconsistent with the return amount, please confirm again!',
	gl: 'Please select a document!',
	gm: 'The current modification has not been saved. Are you sure you want to return?',
	gn: 'Please select a detail!',
	go: 'The record is in the selected list!',
	gp: 'Template name cannot be empty!',
	gq: 'The number of queries has exceeded the upper limit, please modify the query criteria!',
	gr: 'Please select a data!',
	gs: 'The return order number has been matched, it is not allowed to be cleared!',
	gt: 'There are matching return orders in details, please select again!',
	gu: 'Return order details not matched!',
	gv: 'Please input the modification time of refund or platform number!',
	gw: 'Failure reason!',
	gx: 'Failure sequence number',
	gy: 'Failed SKU',
	gz: 'Please fill in the shop nickname!',
	// h------------------------------------------------------------------------
	h0: 'Address information acquisition failed! ',
	h1: "Only warehouse delivery or platform delivery orders can operate! ",
	h2: "Only allow warehouse delivery, platform delivery status orders allow new check orders! ",
	h3: 'Order details acquisition failed',
	h4: 'Barcode is not in the list. Do you want to continue adding? ',
	h5: 'Could to match the corresponding return order, do you want to continue? ',
	h6: 'Your browser does not support audio with your elements. ',
	h7: "This logistics order number exists in the return and warehousing order, so scanning and warehousing is not allowed! ",
	h8: 'Logistics order number must be filled in to force saving',
	h9: 'Scan number cannot be zero! ',
	ha: 'Please select the store type to add!',
	hb: 'Is authorization successful?',
	hc: 'Please input the application time!',
	hd: 'Please choose the order time!',
	he: 'Order time range cannot exceed half an hour, please reset!',
	hf: 'Please input platform modification time or platform number!',
	hg: 'Please fill in',
	hh: 'Please enter the shop nickname!',
	hi: 'Please input vipshop warehouse name!',
	hj: 'Please select the file to import!',
	hk: 'Import failed, Please refer to the file for details',
	hl: 'Please input the product!',
	hm: 'The product does not exist!',
	hn: 'Please select first',
	ho: 'The original platform number cannot be empty!',
	hp: 'Do not add live product identification rules repeatedly!',
	hq: 'Please enter the anchor ID',
	hr: 'Please enter the anchor nickname',
	hs: 'Bar code consistent, please go manual matching!',
	ht: 'Are you sure you want to delete?',
	hu: 'The current modification has not been saved. Are you sure you want to return?',
	hv: 'Automatically close the created receipt document at this time point every day',
	hw: "When the quantity of goods in the same distribution order of 'store + vipshop warehouse + delivery warehouse' is greater than or equal to the set peak value, the stock in order will be created automatically",
	hx: 'The current switching operation will clear the entered contents of create by time point / create by UN picked quantity. Are you sure you want to continue?',
	hy: 'Please select the record to delete first!',
	hz: 'Please select the shop first',
	// i------------------------------------------------------------------------
	i0: 'Return batch cannot be empty! ',
	i1: 'The cancellation of the warehousing warehouse can not be empty! ',
	i2: 'Forced warehousing failed',
	i3: 'Paid-in barcode cannot be empty',
	i4: 'Paid-in barcode is consistent with issuing barcode. Please check and rescan',
	i5: 'This barcode does not exist in the local barcode file, please check and try again',
	i6: 'Please Select a line of record to scan',
	i7: 'Please select a piece of data! ',
	i8: 'Please enter the query conditions! ',
	i9: "No data is available to query! ",
	ia: 'Please do not add again!',
	ib: 'The priority of the same entity warehouse cannot be repeated!',
	ic: 'Please add details first!',
	id: 'Supply proportion cannot be empty!',
	ie: '',
	if: '',
	ig: '',
	ih: '',
	ii: '',
	ij: '',
	ik: '',
	il: '',
	im: '',
	in: '',
	io: '',
	ip: '',
	iq: '',
	ir: '',
	is: '',
	it: '',
	iu: '',
	iv: '',
	iw: '',
	ix: '',
	iy: '',
	iz: '',
	// j------------------------------------------------------------------------
	j0: "Please enter the correct buyer's mobile phone number ",
	j1: 'Original order number cannot be empty! ',
	j2: 'No details to add',
	j3: 'Please select the details that you need to delete! ',
	j4: 'At least one detail, not not delete all! ',
	j5: 'OK to delete the selected details? ',
	j6: 'Refund description request failed',
	j7: 'Hello, hello! Your Order number ',
	j8: 'Because of it',
	j9: 'Reason, apply you',
	ja: 'Please select the warehouse logistics company to delete!',
	jb: 'Enabled status, can not be deleted!',
	jc: 'Please select the document type',
	jd: 'Please fill in the time range',
	je: 'Please fill in the start value and end value you selected',
	jf: 'The end value should be greater than or equal to the start value',
	jg: 'Please select warehouse logistics to add',
	jh: 'Please select the data you want to add',
	ji: 'It is enabled and cannot be edited',
	jj: 'Please select province or city',
	jk: 'Delete returned goods!',
	jl: 'Please confirm whether you want to delete the currently selected returned goods, and there are also associated attached gifts',
	jm: 'Please confirm whether to delete the currently selected returned goods. There are other related goods under the combination / blessing bag',
	jn: 'Failure information!',
	jo: 'And there are also other related commodities under the combination / blessing bag',
	jp: 'Are you sure you want to delete the currently selected returned goods?',
	jq: 'Delete exchange item',
	jr: 'Are you sure you want to delete the currently selected exchange item?',
	js: 'When the refund modification time does not exist, the platform order number and service order number must have both!',
	jt: 'No modification has been made!',
	ju: 'Please select the document for return confirmation!',
	jv: 'Failure details!',
	jw: 'Please select the document to copy!',
	jx: 'Only orders in shortage or pending approval status can be added!',
	jy: 'Please input identification content',
	jz: 'Please do not add the details repeatedly!',
	// k------------------------------------------------------------------------
	k0: 'Additional refund for $ $, we will call you within 3 working days',
	k1: "In, please check! Thank you for your care, welcome you next time, I wish you a happy life! ",
	k2: 'The current operation will store in manually, do you want to continue? ',
	k3: 'Please Select a modification! ',
	k4: 'This check-back status does not allow scanning for warehousing. Please select again! ',
	k5: 'The row is currently selected to use this button! ',
	k6: 'Document status does not meet the audit criteria, please reselect',
	k7: 'Determine the after-sales review? ',
	k8: 'After-sales audit success! ',
	k9: 'After-sales audit failed! ',	
	ka: 'Please select the content to be deleted!',
	kb: "You can't delete all the data in logical warehouse, please keep at least one!",
	kc: 'Details cannot be empty!',
	kd: 'Content cannot be empty!',
	ke: 'Duplicate data, cannot add!',
	kf: 'Only out of stock or pending orders can be added!',
	kg: 'Batch operation is not supported!',
	kh: 'Only orders to be approved are allowed to cancel merging!',
	ki: 'WMS withdrawal and redo operation is only supported for single return order!',
	kj: 'After sales copy button click Check!',
	kk: 'Please select the content to be added!',
	// l------------------------------------------------------------------------
	l0: 'Please select at least one item! ',
	l1: "The cancellation of return and exchange failed. The status of only waiting for the return] can be cancelled. Please check and try again! ",
	l2: 'Document status does not meet the cancellation conditions, please reselect',
	l3: 'Are you sure to cancel the check-back? ',
	l4: "The status of the exchange order is in or shipped. Do you confirm canceling the return directly? ",
	l5: 'Cancel failed! ',
	l6: 'This check-back status does not allow virtual warehousing! ',
	l7: 'Are you sure the virtual warehousing? ',
	l8: 'Virtual warehousing failed! ',
	l9: 'Virtual warehouse warehousing failed! ',
	// m------------------------------------------------------------------------
	m0: 'Cancel the automatic refund failed! ',
	m1: 'Please select at least one modification',
	m2: 'Cancel status is not allowed to modify the comments',
	m3: 'Are you sure the batch is returned? ',
	m4: 'Batch original refund failed! ',
	m5: 'Only waiting for return and warehousing status can be withdrawn from WMS',
	m6: 'Withtraction from wms failed! ',
	m7: 'Heavy WMS failed! ',
	m8: 'Only waiting for after-sales confirmation status can be mandatory! ',
	m9: 'Are you sure to force the completion? ',
	// n------------------------------------------------------------------------
	n0: 'Force completion failed! ',
	n1: 'Select a document for copy! ',
	n2: '.. Continue? ',
	n3: 'Please fill in the original order information first',
	n4: 'Provincial and urban area id acquisition failed',
	n5: 'Copy checkback failed! ',
	n6: 'Failed to get the details! ',
	n7: 'Documents passing the WMS success status are not modifiable! ',
	n8: "Only documents that wait for return and wait for the after-sales confirmation status or completion status and the virtual warehouse can be modified! ",
	n9: 'Documents waiting for return and passing WMS success status cannot be modified! ',
	// o------------------------------------------------------------------------
	o0: 'Store name cannot be empty! ',
	// p------------------------------------------------------------------------
	p0: 'Inidated operation failed',
	p1: 'Return batch required! ',
	p2: 'Special processing type required! ',
	p3: 'Return and warehousing details cannot be empty! ',
	p4: 'Please select a detail for a manual match',
	p5: 'Only one detail can be manually selected',
	p6: 'Status mismatch cannot enter manual matching',
	p7: 'Please select a detail mismatch mandatory match',
	p8: 'Only one detail mismatch force match can be selected',
	p9: 'Status mismatch cannot enter a false hair forced match',
	// q------------------------------------------------------------------------
	q0: 'Selected promotion is offline / expired',
	q1: 'Select a data for a copy operation',
	q2: 'Only one data is selected',
	q3: 'Selected promotions have been released',
	q4: 'Please check the promotion to be grouped',
	q5: 'Promotion exists for [offline expired], please reselect',
	q6: 'This return order has closed and selection is not allowed',
	q7: 'This document is not manually matched',
	q8: 'This document cannot misa mandatory match',
	q9: 'Unidated successful',
	// r------------------------------------------------------------------------
	r0: 'Max imum multiple not filled! ',
	r1: 'Please add goods and gifts first! ',
	r2: 'No data on the merchandise list',
	r3: 'Giveaway List No Data',
	r4: 'Exception for getting promotional details',
	r5: '[meets conditions] select at least one and fill in the quantity or amount condition',
	r6: 'No data',
	r7: 'Problem with batch import resolution',
	r8: 'Query data is empty',
	r9: 'Please select at least one',
	// s------------------------------------------------------------------------
	s0: 'Receiving province is not filled in',
	s1: 'Commodity list data cannot be empty',
	s2: 'List list No',
	s3: 'Line data is not filled out',
	s4: 'Verification is complete',
	s5: 'Event name is not filled in! ',
	s6: 'Store name is not filled in! ',
	s7: 'Order type is required! ',
	s8: 'Offline time is not filled in! ',
	s9: 'Maximum number of restrictions are not filled out! ',
	// t------------------------------------------------------------------------
	t0: 'Please select the barcode to delete! ',
	t1: 'SKU has details, and cannot be deleted',
	t2: 'Please select the portfolio item to delete! ',
	t3: 'Please select a barcode detail first',
	t4: 'Group can only enter a positive integer',
	t5: 'Trial calculation succeeded! ',
	t6: 'Store information is not filled in',
	t7: 'Time Type is not filled in',
	t8: 'Time range is not filled out',
	t9: 'Order Type is not filled in',
	// u------------------------------------------------------------------------
	u0: 'Price is a number, please reasonably enter',
	u1: 'Please select virtual Warehouse',
	u2: 'Please enter the barcode details before saving',
	u3: 'The virtual bar code does not set up the goods, please set it up before saving. ',
	u4: 'Bag type combination commodity A virtual barcode does not allow more than ten groups',
	u5: 'There are extracted rows per group more than the total number of blessing bags for each group',
	u6: "The bag type combination commodity does not allow a SKU, grouping more than 200 rows",
	u7: "Common type combination commodity, more than 30 SKU's are not allowed under a virtual barcode",
	u8: 'Submitted portfolio items cannot be modified! ',
	u9: 'Submitted portfolio items cannot perform deletion! ',
	// v------------------------------------------------------------------------
	v0: 'Please select a correct commodity bar code',
	v1: 'The product quantity cannot be empty! ',
	v2: 'Number of goods is a number, please enter reasonably',
	v3: 'Group cannot be empty! ',
	v4: 'Group is a number, please enter it reasonably',
	v5: 'Please select the barcode information to enter the item details',
	v6: 'Commodity code cannot be empty',
	v7: 'Commodity code consists of English letters and numbers, please enter reasonably',
	v8: 'Please select the Brand',
	v9: 'Price must not be empty',
	// w------------------------------------------------------------------------
	w0: 'Item quantity can only enter a positive integer',
	w1: 'The number of drawn rows per group is only a positive integer',
	w2: 'Switching portfolio commodity type empty data and confirm switching portfolio commodity type',
	w3: 'Cannot modify',
	w4: 'Virtual bar code is required, and cannot be empty',
	w5: 'Virtual bar code consists of English letters and numbers, please enter reasonably',
	w6: 'Each group of drawn rows is a number, please enter them reasonably',
	w7: 'Current',
	w8: 'Existing exists, save not allowed',
	w9: 'Commodity bar code cannot be empty! ',
	// x------------------------------------------------------------------------
	x0: 'Physical warehouse cannot be empty',
	x1: 'Effective date cannot be empty',
	x2: 'End date cannot be empty',
	x3: 'Schema name cannot be empty',
	x4: 'Details are empty not allowed',
	x5: 'Compensation criteria and multiple cannot be empty',
	x6: 'Settlement price cannot be empty',
	x7: 'Express company name cannot be empty',
	x8: 'Virtual bar code consists of English letters and numbers, please enter reasonably',
	x9: 'Commodity name cannot be empty',
	xa: 'Please select the required new giveaway',
	// y------------------------------------------------------------------------
	y0: 'Save failed! ',
	y1: 'cannot be empty! ', // AAA cannot be empty.
	y2: 'Confirm for the export? ',
	y3: 'Too large, use the import feature to arrive! ',
	y4: 'Unidated successfully! ',
	y5: 'Inoid failed! ',
	y6: 'Export failed! ',
	y7: 'Please select the logistics area! ',
	y8: 'The logistics priority is empty, save will cause the data to delete, do you like to confirm the save? ',
	y9: 'Repeat the priority settings! ',
	ya: 'The opening bank cannot be empty',
	yb: 'Bank account number cannot be empty',
	yc: "The current operation will mark the order with urgent delivery [urgent], please confirm! ",
	yd: 'Members rushed urgently and marked successfully',
	ye: 'Please select the Logistics Company',
	yf: 'Previous replacement sku cannot be empty',
	yg: 'Item sku code cannot be empty after replacement',
	yh: 'Reements cannot be the same as those replaced',
	yi: 'Please fill in the consignee cell phone',
	yj: 'Please fill in the consignee name',
	yk: 'Please fill in the province! ',
	yl: 'Please fill in the city! ',
	ym: 'Please complete the detailed address! ',
	yn: 'Ship nee phone is not legal',
	yo: 'Ship nee phone is not legal',
	yp: 'Postal code is not legal',
	yq: 'Ship nee phone is not legal',
	yr: 'Please fill in the province correctly',
	ys: 'Please fill in the city correctly',
	yt: 'Please fill in the district and county correctly',
	yu: 'Provincial query failed',
	yv: 'Please select the province first',
	yw: 'City query failed',
	yx: 'Please select the City first',
	yy: 'District query failed',
	yz: 'Please select the order data',
	// z------------------------------------------------------------------------
	z0: 'The current operation performs a full export, and the export time may be relatively slow! Continue with the export? ',
	z1: 'Anti-customer trial success! ',
	z2: 'Export succeeded! ',
	z3: 'Failed! ',
	z4: 'List has no data, and cannot be exported! ',
	z5: 'The voucher will be deleted after you click. Do you want to continue? ',
	z6: 'Quantity can only enter a positive integer! ',
	z7: 'Amount payable can only enter entered greater than 0! ',
	z8: 'Failed to get the details! ',
	z9: 'Save successfully! ',
	za: 'Note: Do not place macro or icons in the upload file, change the order of columns, and use formulas in the data. ',
	zb: 'Fmaximum 64M',
	zc: 'Please wait... while the data is being imported',
	zd: 'Import failed',
	ze: 'Import succeeded',
	zf: 'Will',
	zg: 'Replace with',
	zh: 'Confirmation fy comments! ',
	zi: 'Please select the Warehouse',
	zj: 'Warehouse list cannot be empty',
	zk: 'Select at least one order detail',
	zl: 'Please Select one of the records',
	zm: 'Please select a record',
	zn: 'HOLD single cause cannot be empty',
	zo: 'The specified time point release time cannot be empty',
	zp: 'The specified time point release time cannot be less than the current time',
	zq: 'Fixed time released after a fixed time can only be an integer',
	zr: 'The relevant data released after fixed time cannot be empty',
	zs: 'Point cannot be empty when release',
	zt: 'sku query failed',
	zu: 'Please tick the order data',
	zv: 'Special invoices must be confirmed with the invoicing Commissioner',
	zw: 'Invoice header cannot be empty',
	zx: 'The ID number cannot be empty',
	zy: 'Company address cannot be empty',
	zz: 'Phone number cannot be empty',
}